import { apiEndpoint } from 'mypages-library';
import { getRedirectValue, getTargetRedirectValue, getOAuthRedirectValue } from './urlParser';
import { trackEvent } from './google/util';

export const navigationUrl = async (language: string) => {
  // Check if we have an oauth redirect url, this has the highest priority
  const oauthUrl = getOAuthRedirectValue();
  if (oauthUrl !== null) {
    return oauthUrl;
  }

  // Check if we have a redirect target
  const targetUrl = await getTargetRedirectValue(language);
  if (targetUrl !== null) {
    return targetUrl;
  }

  let url = `/${language}/status`;

  // For backwards compatibility we need to support the old redirect parameter
  // This should be removed when the old redirect parameter is no longer used by any clients
  const redirectUrl = getRedirectValue();
  if (redirectUrl) {
    url = redirectUrl;
    if (url.startsWith('/')) {
      url = `/${language}${url}`;
    } else {
      url = `/${url}`;
    }
  }
  return url;
};

export const navigateTo = async (language: string) => {
  trackEvent({
    eventCategory: 'open',
    eventAction: 'mypages',
  });
  const url = await navigationUrl(language);
  window.location.replace(url);
};

export const navigateToLogin = () => {
  const currentEnv = apiEndpoint.getCurrentEnvironment(apiEndpoint.getHostName());
  // will always go to prod if not specified and can only specify mpTargetEnvironment in test envs
  switch (currentEnv) {
    case 'local':
    case 'test':
      window.location.href = 'https://galactica-app.dev.verisure.com/home?mpTargetEnvironment=galactica';
      break;
    case 'kobol':
      window.location.href = 'https://kobol-app.dev.verisure.com/home?mpTargetEnvironment=kobol';
      break;
    case 'caprica':
      window.location.href = 'https://caprica-app.dev.verisure.com/home?mpTargetEnvironment=caprica';
      break;
    case 'systest':
      window.location.href = 'https://app.sys.verisure.com/home?mpTargetEnvironment=sys';
      break;
    default:
      window.location.href = 'https://app.verisure.com/home';
  }
};
